import script from "./ResizeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ResizeTable.vue?vue&type=script&setup=true&lang=js"

import "./ResizeTable.vue?vue&type=style&index=0&id=6afdb194&lang=css"

const __exports__ = script;

export default __exports__